"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var stimulus_1 = require("stimulus");
var validator_1 = __importDefault(require("~/validator/validator"));
var EmailValidatableController = /** @class */ (function (_super) {
    __extends(EmailValidatableController, _super);
    function EmailValidatableController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.connect = function () {
            var _a;
            (0, jquery_1.default)(_this.element).on('submit', function () {
                var _a;
                var invalidElements = _this.emailInputTargets
                    ? _this.emailInputTargets.filter(function (target) {
                        return (target.required || target.value) && !validator_1.default.validateEmail((0, jquery_1.default)(target).val());
                    })
                    : [];
                (_a = _this.emailInputTargets) === null || _a === void 0 ? void 0 : _a.forEach(function (elt) { return _this.changeStyle(elt, false); });
                invalidElements.forEach(function (elt) { return _this.changeStyle(elt, true); });
                return invalidElements.length === 0;
            });
            (_a = _this.emailInputTargets) === null || _a === void 0 ? void 0 : _a.forEach(function (elt) {
                (0, jquery_1.default)(elt).on('change keyup', function () { return _this.changeStyle(elt); });
            });
        };
        _this.changeStyle = function (elm, isWarning) {
            if (isWarning === void 0) { isWarning = false; }
            if (isWarning) {
                (0, jquery_1.default)(elm).addClass('is-warning');
            }
            else {
                (0, jquery_1.default)(elm).removeClass('is-warning');
            }
        };
        return _this;
    }
    EmailValidatableController.targets = ['emailInput', 'submitButton'];
    return EmailValidatableController;
}(stimulus_1.Controller));
exports.default = EmailValidatableController;
